import { GET_HEADER_NOTIFICATION } from "./actions";

const initialState = {
  headerNotificationList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  loading: true,
};

const headerNotificationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_HEADER_NOTIFICATION:
      return {
        ...state,
        headerNotificationList: payload,
        loading: false,
      };

    default:
      return state;
  }
};
export default headerNotificationReducer;
